export default {
  addEvent: (state, payload) => {
    state.events.push(payload);
    if (state.events.length > 90) {
      state.events = state.events.slice(-90);
    }
    localStorage.setItem('access-events', JSON.stringify(state.events));
  }
}
